export default __webpack_public_path__ + "static/media/news (2).a0f6b8ef.webp";